<div class="app-container">
    <public-navigation></public-navigation>
    <router-outlet></router-outlet>
</div>
